import React, { useState } from 'react';
import CountUp from 'react-countup';
import VisibilitySensor from 'react-visibility-sensor';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LanguageIcon from '@mui/icons-material/Language';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import LiveTvIcon from '@mui/icons-material/LiveTv';

const Metrics = () => {
  const theme = useTheme();
  const [viewPortEntered, setViewPortEntered] = useState(false);
  const setViewPortVisibility = (isVisible) => {
    if (viewPortEntered) return;
    setViewPortEntered(isVisible);
  };

  const getIcon = (iconName) => {
    const iconProps = { sx: { fontSize: 40, color: theme.palette.primary.main } };
    switch (iconName) {
      case 'OndemandVideoIcon':
        return <OndemandVideoIcon {...iconProps} />;
      case 'LiveTvIcon':
        return <LiveTvIcon {...iconProps} />;
      default:
        return <LanguageIcon {...iconProps} />;
    }
  };

  const metricsData = [
    {
      title: 4,
      label: 'Episodios On-Demand disponibles',
      subtitle: 'Temporada en crecimiento en TNO Network.',
      suffix: '+',
      icon: getIcon('OndemandVideoIcon'),
    },
    {
      title: 30000,
      label: 'Visitas mensuales del ecosistema TNO',
      subtitle: 'Web, app y contenido On-Demand.',
      suffix: '+',
      icon: getIcon('LanguageIcon'),
    },
    {
      title: 90,
      label: 'Seguidores del ecosistema social TNO Network',
      subtitle: 'Alcance multiplataforma para amplificar tu mensaje.',
      suffix: 'K+',
      icon: getIcon('LanguageIcon'),
    },
    {
      title: 1,
      label: 'Emisión en vivo semanal',
      subtitle: 'Lunes 10:00 AM (Venezuela) · Comercio Corporativo.',
      suffix: '',
      icon: getIcon('LiveTvIcon'),
    },
  ];

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography sx={{ textTransform: 'uppercase', fontWeight: 'medium' }} gutterBottom color={'primary'} align={'center'}>
          Números
        </Typography>
        <Box component={Typography} fontWeight={700} variant={'h3'} align={'center'} gutterBottom color={'primary'}>
          Los números de Comercio Corporativo
        </Box>
        <Typography variant={'h6'} align={'center'} color="textSecondary" sx={{ mb: 4 }}>
          Tu marca llega a ejecutivos, emprendedores y profesionales que buscan información útil para decidir.
        </Typography>
      </Box>
      <Box marginBottom={{ xs: 4, sm: 8, md: 8 }}>
        <Grid container spacing={2}>
          {metricsData.map((item, i) => (
            <Grid key={i} item xs={12} sm={6} md={3}>
              <Box display="flex" justifyContent="center" alignItems="center" marginBottom={2}>
                {item.icon}
              </Box>
              <Typography variant="h3" align={'center'} gutterBottom>
                <Box fontWeight={600}>
                  <VisibilitySensor onChange={(isVisible) => setViewPortVisibility(isVisible)} delayedCall>
                    <CountUp redraw={false} end={viewPortEntered ? item.title : 0} start={0} suffix={item.suffix} />
                  </VisibilitySensor>
                </Box>
              </Typography>
              <Typography align={'center'} variant="h6" gutterBottom>
                {item.label}
              </Typography>
              <Typography color="text.secondary" align={'center'} component="p">
                {item.subtitle}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Metrics;
